export default __webpack_public_path__ + "static/media/link-icon.0b3a1cd7.svg";